module.exports = __webpack_public_path__ + "static/sunflower-b7492845fbf6cc056878c77bf4a3b9fd.jpg";